import { PartnershipLegalForm, PartnershipStatus } from '@/types/partnership';
import { NaturalPersonGender } from '@/types/naturalPerson';
import { PhoneNumber, PostalAddress } from '@/types/address';
import { YapMoney } from '@/types/general';

export enum TeamSpaceView {
  Members = 'members',
  MemberDetails = 'member-details',
  Invitations = 'invitations'
}

export enum MembersActionId {
  AdminAdd = 'add-admin',
  AdminRemove = 'remove-admin',
  MemberRemove = 'remove-member',
  SignatoryRemove = 'remove-signatory'
}

export enum MemberAction {
  Add = 'add',
  Remove = 'remove'
}

export interface RoleRemovalImpact {
  delegateReductionImpact: {
    contractualEntitlements: string[];
    numCardPrograms: number;
    numDebitCards: number;
  };
  partnerReductionImpact: {
    resultingVotingWeight: number;
  };
}

export interface Invitation {
  cancellationReason: string;
  partnershipDetails: {
    partnershipFullName: string;
    partnershipLegalForm: PartnershipLegalForm;
    partnershipRole: string;
    partnershipStatus: PartnershipStatus;
    partnershipUid: string;
    withAdminRole: boolean;
    withAllRightsFunction: string;
  };
  prospectContext: {
    emailAddress: string;
    emailAddressIsVerified: boolean;
    name: {
      names?: string[];
      givenNames?: string[];
    };
    nationality: string;
    nickName: string;
    personalData: {
      dateOfBirth: string;
      gender: NaturalPersonGender;
      honorific: string;
      nationalities: string[];
      placeOfBirth: string;
      placeOfOrigin: string;
      title: string;
    };
    phoneNumber: PhoneNumber;
    postalAddress: PostalAddress;
  };
  status: 'active' | 'cancelled' | 'expired' | 'new' | 'registered' | 'retired';
  type: 'buddy' | 'partnership' | 'yapini';
  validUntilTime: string;
  voucherCode: string;
  yapiniDetails: {
    initialAmount: YapMoney;
    pricePlanCode: string;
    transferred: boolean;
  };
}

export interface MemberActionConfirmModal {
  id: string;
  title: string;
  text: string | string[];
  data?: {
    numCardPrograms?: number;
    numDebitCards?: number;
    resultingVotingWeight?: number;
  };
}

export enum RoleFilterOptions {
  All = 'all',
  Signatory = 'signatory',
  Member = 'member-filter',
  Admin = 'admin',
  Cardholder = 'cardholder'
}
